



import LineChart, {ChartDataSet} from '@/components/charts/LineChart';
import {NumberType} from '@/components/charts/numbers';
import {TimeUnit} from 'chart.js';
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class LineChartControl extends Vue {
  @Prop({type: Array, required: true})
  public readonly dataSets: ChartDataSet[];

  @Prop({type: String, required: true})
  public readonly period: TimeUnit;

  @Prop({type: String, required: true})
  public readonly numberType: NumberType;

  @Prop({type: String, required: true})
  public readonly axisYTitle: string;

  @Prop({type: String, required: true})
  public readonly language: string;

  @Prop({type: String, required: true})
  public readonly currency: string;

  @Prop({type: Boolean, default: true})
  public readonly legend: boolean;

  private chart: LineChart;

  public mounted(): void {
    this.chart = new LineChart(
        this.$refs.chart as HTMLCanvasElement,
        this.axisYTitle,
        this.dataSets,
        this.period,
        this.numberType,
        this.language,
        this.currency,
        this.legend,
    );
  }
}
